export default __webpack_public_path__ + "static/media/city-of-muncie.b7f68d1b.png";